export const getMessage = (key, messages) => {
	let message = messages[key]?.toString() || key
	return message
}
